import { Component, OnInit } from '@angular/core';
interface Infosalary {
  sqd: string;
  nqd: string;
  nhl: string;
  lqd: string;
  ngach: string;
  bac: string;
  heso: number;
  luong: number;
}
@Component({
  selector: 'app-demo',
  templateUrl: './demo.component.html',
  styleUrls: ['./demo.component.scss']
})
export class DemoComponent implements OnInit {
  listOfData: Infosalary[] = [
    {
      sqd: '4521',
      nqd: '20/12/2018',
      nhl: '20/12/2018',
      ngach: '4521',
      lqd: '2107',
      bac: 'Trung cấp',
      heso: 2,
      luong: 12000000,
    },
    {
      sqd: '4521',
      nqd: '20/12/2018',
      nhl: '20/12/2018',
      ngach: '4521',
      lqd: '2107',
      bac: 'Trung cấp',
      heso: 2,
      luong: 12000000,
    },
    {
      sqd: '4521',
      nqd: '20/12/2018',
      nhl: '20/12/2018',
      ngach: '4521',
      lqd: '2107',
      bac: 'Trung cấp',
      heso: 2,
      luong: 12000000,
    },
  ];
  constructor() { }

  ngOnInit() {
  }

}
